import { useQuerystring } from "$routes/_lib/use-querystring";
import { useCallback, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const INVOICE_ID_PARAM = "invoiceId";

export const useInvoiceDeeplink = ({
  invoiceId,
  defaultExpanded,
}: {
  invoiceId: string;
  defaultExpanded: boolean;
}): { expanded: boolean; toggleExpanded: () => void } => {
  const { [INVOICE_ID_PARAM]: deeplinkId } = useQuerystring();
  const navigate = useNavigate();
  const location = useLocation();
  const [expanded, setExpanded] = useState(
    defaultExpanded || deeplinkId === invoiceId,
  );

  const toggleExpanded = useCallback(() => {
    const params = new URLSearchParams(location.search);
    if (expanded) {
      if (params.get(INVOICE_ID_PARAM) === invoiceId) {
        params.delete(INVOICE_ID_PARAM);
      }
    } else {
      params.set(INVOICE_ID_PARAM, invoiceId);
    }
    navigate(
      { pathname: location.pathname, search: params.toString() },
      { replace: true },
    );
    setExpanded((current) => !current);
  }, [expanded, invoiceId, location.pathname, location.search, navigate]);

  return { expanded, toggleExpanded };
};
